"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.scaleToFit = scaleToFit;
exports.isShutterstock = isShutterstock;
exports.isEditableImage = isEditableImage;
exports.shouldRecalculateDimensions = exports.hasDimensions = void 0;

var _immutable = _interopRequireDefault(require("immutable"));

var _file = require("./file");

var _fileAccessibility = require("./fileAccessibility");

var EDITABLE_EXTENSIONS = _immutable.default.Set(['jpg', 'jpeg', 'png', 'gif', 'webp']);

var hasDimensions = function hasDimensions(file) {
  return file.get('width') && file.get('height');
};

exports.hasDimensions = hasDimensions;

var shouldRecalculateDimensions = function shouldRecalculateDimensions(file) {
  return (0, _file.getIsImage)(file) && !(0, _file.getIsSvg)(file) && !hasDimensions(file);
};

exports.shouldRecalculateDimensions = shouldRecalculateDimensions;

function scaleToFit(file, size) {
  if (!hasDimensions(file)) {
    return {
      width: size,
      height: null
    };
  }

  var width = file.get('width');
  var height = file.get('height');
  var scale = Math.min(1, size / Math.max(width, height));
  return {
    width: Math.min(size, Math.floor(width * scale)),
    height: Math.min(size, Math.floor(height * scale))
  };
}

function isShutterstock(file) {
  return file.hasIn(['meta', 'shutterstock_id']);
}

function isEditableImage(file) {
  return EDITABLE_EXTENSIONS.includes(file.get('extension')) && !isShutterstock(file) && !(0, _fileAccessibility.getIsFilePrivate)(file);
}